import React, { useEffect, useState } from "react";
import { BellRing, Bell, Share } from "lucide-react";
import { toast } from "sonner";
import { getSubscription, permission, pushSupported, needsHomeScreen } from "@/lib/push";

export function HomeScreenHint({ dark = false }) {
  return (
    <p className={`text-xs flex items-center gap-1 flex-wrap ${dark ? "text-stone-400" : "text-muted-foreground"}`} data-testid="push-ios-hint">
      No iPhone: toque em <Share className="w-3.5 h-3.5 inline" /> Compartilhar → "Adicionar à Tela de Início" e abra o site pelo ícone para ativar os avisos.
    </p>
  );
}

// Customer prompt shown on the site; subscription is linked to the order at checkout.
export default function CustomerPushPrompt() {
  const [state, setState] = useState("hidden");

  useEffect(() => {
    if (needsHomeScreen()) setState("ios");
    else if (pushSupported() && permission() === "default") setState("ask");
  }, []);

  if (state === "hidden") return null;

  const enable = async () => {
    try {
      const sub = await getSubscription(true);
      if (sub) {
        toast.success("Pronto! Você vai receber os avisos do seu pedido.");
        setState("hidden");
      } else if (permission() === "denied") {
        toast.error("Notificações bloqueadas. Libere nas configurações do navegador.");
        setState("hidden");
      }
    } catch {
      toast.error("Não foi possível ativar as notificações.");
    }
  };

  return (
    <div className="bg-secondary/15 border-b border-border" data-testid="customer-push-prompt">
      <div className="max-w-6xl mx-auto px-5 py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <p className="text-sm font-medium flex items-center gap-2 flex-1">
          <BellRing className="w-4 h-4 text-primary shrink-0" />
          Receba no celular os avisos do seu pedido: confirmado, em preparo, saiu para entrega...
        </p>
        {state === "ask" ? (
          <div className="flex gap-2">
            <button onClick={enable} data-testid="customer-push-enable-btn"
              className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:bg-primary/90 transition-colors">
              <Bell className="w-4 h-4" /> Ativar avisos
            </button>
            <button onClick={() => setState("hidden")} data-testid="customer-push-dismiss-btn"
              className="rounded-full border border-border px-4 py-2 text-sm hover:bg-muted transition-colors">
              Agora não
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <HomeScreenHint />
            <button onClick={() => setState("hidden")} data-testid="customer-push-dismiss-btn" className="text-xs underline text-muted-foreground">Fechar</button>
          </div>
        )}
      </div>
    </div>
  );
}
